export const SET_CONTACTS_FILTERS = 'SET_CONTACTS_FILTERS';

export const setAgenciesFilters = ({ searchText }) => ({
    type: SET_CONTACTS_FILTERS,
    payload: {
        searchText
    }
});
